import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './ComicCards.module.css';
import Script1 from '../../images/comic-script-1.jpg'
import Script2 from '../../images/The-Midnight-Snack-Monster.jpg'

const ComicCards = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const comicScripts = [
    {
      id: 1,
      title: "A Tiny Bite of Kindness",
      subtitle: "Tiny Bite, Big Kindness",
      description: "A small ant is saved by a dove, and later the ant returns the favor by protecting the dove from danger. A simple story showing how kindness always comes back.",
      image: Script1
    },
    {
      id: 2,
      title: "The Midnight Snack Monster",
      subtitle: "A Silly Midnight Scare",
      description: "A girl sneaks for cookies and gets spooked by her own pets in a funny late-night adventure.",
      image: Script2
    }
  ];

  const renderHome = () => (
    <div className={styles.homeContainer}>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      {/* Animated Background */}
      <div className={styles.animatedBg}>
        <div className={styles.particlesContainer}>
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={styles.particle}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`
              }}
            />
          ))}
        </div>
        <div className={`${styles.gradientOrb} ${styles.orb1}`}></div>
        <div className={`${styles.gradientOrb} ${styles.orb2}`}></div>
        <div className={`${styles.gradientOrb} ${styles.orb3}`}></div>
      </div>

      {/* Main Content */}
      <div className={styles.contentWrapper}>
        <div className={styles.headerSection}>
          <div className={styles.badge}>Featured Scripts</div>
          <h1 className={styles.heroTitle}>
            <span className={styles.titleLine}>Discover Your Next</span>
            <span className={`${styles.titleLine} ${styles.gradientText}`}>Comic Adventure</span>
          </h1>
          <p className={styles.heroSubtitle}>Explore immersive stories crafted by talented creators</p>
        </div>

        <div className={styles.cardsGrid}>
          {comicScripts.map((script, index) => (
            <div
              key={script.id}
              className={styles.card}
            >
              <div className={styles.cardImageWrapper}>
                <img src={script.image} alt={script.title} className={styles.cardImage} />
              </div>

              <div className={styles.cardBody}>
                <h2 className={styles.cardTitle}>{script.title}</h2>
                <h3 className={styles.cardSubtitle}>{script.subtitle}</h3>
                <p className={styles.cardDescription}>{script.description}</p>

                <button
                  className={styles.cardBtn}
                  onClick={() => navigate('/comic-script', { state: script })}
                >
                  <span>Read Script</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer mode={mode} />
    </div>
  );

  return renderHome();
};


export default ComicCards;